<template>
  <div class="form-status-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="statusOptions"
      display-by="label"
      value-by="value"
      :multiple="true"
      v-model="model"
      search-placeholder="Search status..."
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';

const props = defineProps({
  label: { 
    type: String, 
    default: 'Status' 
  }
});

const emit = defineEmits<{
  change: [value: boolean[]];
}>();

const model = defineModel<boolean[]>({
  default: () => []
});

const statusOptions = ref([
  { label: 'Active', value: true },
  { label: 'Inactive', value: false }
]);

const handleChange = (value: boolean[]) => {
  emit('change', value);
};
</script>
